/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSplitScheduledTransactionGetRequestFromDiscriminatorValue, serializeSplitScheduledTransactionPutRequest, type SplitScheduledTransactionGetRequest, type SplitScheduledTransactionPutRequest } from '../../../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/splits/{splitId}/scheduledtransactions
 */
export interface ScheduledtransactionsRequestBuilder extends BaseRequestBuilder<ScheduledtransactionsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SplitScheduledTransactionGetRequest[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SplitScheduledTransactionGetRequest[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     put(body: SplitScheduledTransactionPutRequest[], requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SplitScheduledTransactionPutRequest[], requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ScheduledtransactionsRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/splits/{splitId}/scheduledtransactions";
/**
 * Metadata for all the requests in the request builder.
 */
export const ScheduledtransactionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ScheduledtransactionsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSplitScheduledTransactionGetRequestFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ScheduledtransactionsRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSplitScheduledTransactionPutRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
